// extracted by mini-css-extract-plugin
export var hideNav = "navbar-desktop-module--hideNav--da2b9";
export var item = "navbar-desktop-module--item--eb498";
export var link = "navbar-desktop-module--link--51d0d";
export var menu = "navbar-desktop-module--menu--14c86";
export var navBtn = "navbar-desktop-module--navBtn--94d74";
export var navBtnExpand = "navbar-desktop-module--navBtnExpand--bda2f";
export var navbar = "navbar-desktop-module--navbar--652d3";
export var submenu = "navbar-desktop-module--submenu--1fa47";